import LotusMark from './LotusMark.jsx';
import { DONATE_URL } from '../support.js';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__statement shell">
        <LotusMark />
        <p>Together, we build healthier, stronger, and more resilient communities.</p>
      </div>
      <div className="site-footer__grid shell">
        <div>
          <a className="brand brand--footer" href="/">
            <LotusMark className="brand__mark" />
            <span><strong>Transformational</strong><em>Wellness</em></span>
          </a>
          <p>Presented by the Khmer Educational Endowment Network (K.E.E.N.), in partnership with the Power of One Foundation.</p>
        </div>
        <div>
          <h2>Explore</h2>
          <a href="/sf">San Francisco</a>
          <a href="/our-story">Our Story</a>
          <a href="/board">Board & Leadership</a>
          <a href="/pillars">The Seven Pillars</a>
          <a href="/wellness-week">Wellness Week</a>
        </div>
        <div>
          <h2>Connect</h2>
          <a href="/project-cambodia">Project Cambodia</a>
          <a href="/partner">Partnerships</a>
          <a href="/fiscal-sponsor">Fiscal sponsor</a>
          <a href={DONATE_URL} target="_blank" rel="noopener noreferrer">Donate</a>
          <a href="/contact">Contact</a>
          <a href="/assets/keen-transformational-wellness-deck.pdf">Partnership deck</a>
        </div>
        <div className="site-footer__city">
          <h2>City chapter</h2>
          <strong>San Francisco</strong>
          <p>Our first five-day community experience.</p>
          <a href="/sf">Visit /sf <span aria-hidden="true">→</span></a>
        </div>
      </div>
      <div className="site-footer__base shell">
        <span>© {new Date().getFullYear()} Transformational Wellness</span>
        <span>One purpose. One movement. Limitless impact.</span>
      </div>
    </footer>
  );
}
